import { render } from "./card1.vue?vue&type=template&id=f6967b1c&scoped=true"
import script from "./card1.vue?vue&type=script&lang=js"
export * from "./card1.vue?vue&type=script&lang=js"

import "./card1.vue?vue&type=style&index=0&id=f6967b1c&lang=scss&scoped=true"

import exportComponent from "/Users/baikaifa/Desktop/ubang-deploy-work/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6967b1c"]])

export default __exports__